<template>
  <div
    class="hamburger"
    :class="{
      'hamburger--active': menuIsOpen,
    }"
  >
    <span />
    <span />
    <span />
  </div>
</template>

<script setup>
// menuStore
import { useMenuStore } from "store/modules/menuStore.js";
import { storeToRefs } from "pinia";

const menuStore = useMenuStore();
const { menuIsOpen } = storeToRefs(menuStore);
</script>

<style lang="scss" scoped>
.hamburger {
  @apply tw-relative tw-aspect-square tw-w-[20px]  tw-cursor-pointer;

  span {
    @apply tw-absolute tw-left-0 tw-h-px tw-w-[90%] tw-bg-gray-900 tw-transition-all;

    &:nth-child(1) {
      @apply tw-top-1/4 tw-translate-y-1/4;
    }
    &:nth-child(2) {
      @apply tw-top-1/2 -tw-translate-y-1/2;
    }
    &:nth-child(3) {
      @apply tw-top-3/4 -tw-translate-y-3/4;
    }
  }

  &--active span {
    &:nth-child(1) {
      @apply tw-top-1/2 tw-rotate-45;
    }
    &:nth-child(2) {
      @apply tw-scale-0;
    }
    &:nth-child(3) {
      transform: rotate(-45deg);
      @apply tw-bottom-auto tw-top-1/2;
    }
  }
}
</style>
